<template>
  <div>
      <div class="ewmbox" v-if="isShow">

        <div class="smallEwm" >
          <el-popover
              placement="right"
              trigger="click"
              width="150"
              @hide="hideEvent"
              @show="showEvent"
              popper-class="popper-class"
              >
            <img :src="base64" alt="" width="150" height="150" v-if="flag == 0">
            <img src="@/assets/images/success.png" alt="" style="margin-bottom: 20px" width="30" height="30" v-else-if="flag == 1">
            <img src="@/assets/images/fail.png" alt="" style="margin-bottom: 20px"  width="30" height="30" v-else>

            <span :class="flag == 2 ?'canClick' : '' " @click="refreshCode">{{text}}</span>
            <div slot="reference" >
              <img src="@/assets/images/exampleEwm.png" height="50" width="50"/>
              <span>点击扫码，绑定微信</span>
            </div>
          </el-popover></div>
      </div>

  </div>
</template>

<script>
import {getInfo, getUserInfo} from "@/api/userFile";
import QRCode from 'qrcode'
import user from "@/store/modules/user";
  export default {
    name:'ewm',
    data(){
      return {
        isShow:false,
        base64:undefined,
        timer: null,
        // 0 等待中 1 成功 2 失败
        flag:0,
        text:'微信扫码绑定',


      }
    },
    created() {
        // JSON.parse(sessionStorage.getItem('userInfo')).userId ? this.isShow = true : this.isShow = false
        this.show()
      },
    methods:{
      show(){
        let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
        if(!userInfo || userInfo.unionId){
          this.isShow = false
        }else if(userInfo && !userInfo.unionId){
          this.isShow = true
        }
      },
      showEvent(){
        let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
        let url = 'https://qybz.hrss.henan.gov.cn/wechatBinding.html?state='+userInfo.userId
        this.text = '微信扫码绑定'
        // return
        this.flag = 0
        console.log(url)
        QRCode.toDataURL(url,{
          width: 150,
          height: 150,
          ref:'canvas'

        }).then(base64 =>{
          this.base64 = base64
          console.log(base64)
        }).catch(err=>{
          console.log(err)
        })
        this.timer = setInterval(()=>{
          getInfo(userInfo.userId).then(res=>{
            console.log(res.data)
            if(res.code == 200){
              // if(res.flag == )
              if(res.data.wechatStatus == 0){
                this.flag = 2
                this.text = '绑定失败，刷新重试！'
                clearInterval(this.timer)
              }else if(res.data.wechatStatus == 1){
                this.flag = 1
                this.text = '绑定成功！'
                clearInterval(this.timer)
                sessionStorage.setItem('userInfo',JSON.stringify(res.data))
                sessionStorage.setItem('token', res.token || '')
                setTimeout(()=>{
                  this.isShow = false
                },5000)
              }
            }
          }).catch(()=>{

          })
        },2000)

      },
      refreshCode(){
        let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
        let url = 'http://ldgx-sl.zeda.com.cn?state='+userInfo.userId
        this.text = '微信扫码绑定'
        // return
        this.flag = 0
        console.log(url)
        QRCode.toDataURL(url,{
          width: 150,
          height: 150,
          ref:'canvas'

        }).then(base64 =>{
          this.base64 = base64
          console.log(base64)
        }).catch(err=>{
          console.log(err)
        })
        this.timer = setInterval(()=>{
          getInfo(userInfo.userId).then(res=>{
            console.log(res.data)
            if(res.code == 200){
              // if(res.flag == )
              if(res.data.wechatStatus == 0){
                this.flag = 2
                this.text = '绑定失败，刷新重试！'
                clearInterval(this.timer)
              }else if(res.data.wechatStatus == 1){
                this.flag = 1
                this.text = '绑定成功！'
                clearInterval(this.timer)
                sessionStorage.setItem('userInfo',JSON.stringify(res.data))
                sessionStorage.setItem('token', res.token || '')
                setTimeout(()=>{
                  this.isShow = false
                },5000)
              }
            }
          }).catch(()=>{

          })
        },2000)
      },
      hideEvent(){
        if(this.timer){
          clearInterval(this.timer)
        }
      }
    }
  }
</script>
<style lang="scss">
  .ewmbox{
    position: absolute;
    top: 400px;
    right: 20px;
    .smallEwm{
      cursor: pointer;
      span{
        font-size: 12px;
      }
    }
  }
  .popper-class{
    display: flex;
    flex-direction: column !important;
    align-items: center;
    justify-content: center;
    min-height: 150px;
  }
  .smallEwm .el-popover__reference{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .canClick{
    color: #409eff;
    cursor: pointer;
    text-decoration: underline;
  }
</style>
